var exports = {
  "Os": "group__i-sw4v",
  "c0": "hasSeparator__DZ8QkP",
  "DD": "title__g2f4Ur",
  "p_": "list__GYi3Jn",
};

module.exports = exports;
